import { useNotification } from './notifications.context';
import { createNotificationMethods } from './notifications.helpers';
import type { NotificationConfig, NotificationMethod } from './notifications.type';

/**
 * React hook for showing notifications within components.
 * This provides the same functionality as the `toast` utility, but as a hook
 * which may be preferred in React components.
 *
 * @returns {Object} Methods for showing and hiding notifications
 */
const useToast = (): {
  showSuccess: NotificationMethod;
  showWarning: NotificationMethod;
  showError: NotificationMethod;
  showNotification: (config: NotificationConfig) => string;
  hideNotification: (id: string) => void;
} => {
  const { showNotification, hideNotification } = useNotification();

  const { showSuccess, showWarning, showError } = createNotificationMethods(showNotification);

  return {
    showSuccess,
    showWarning,
    showError,
    showNotification,
    hideNotification,
  };
};

export { useToast };
